export default "__VITE_ASSET__1877dec2__"